export const NavbarData = [
    {
        title: "Home",
        path: "/"
    },
    {
        title: "About",
        path: "/about"
    },
    {
        title: "DataStructures",
        path: "/datastructures"
    },
    {
        title: "Big O Notation",
        path: "/bigonotation"
    },
    {
        title: "Links",
        path: "/links"
    },
    {
        title: "Contact",
        path: "/contact"
    }
]